import styled from 'styled-components'

type StyledProps = {
  draftOpened: boolean;
}

const StyledAppLayout = styled.div<StyledProps>`
  display: grid;
  align-content: start;
  grid-template-columns: minmax(0, 1fr);

  .sidebar-container {
    display: contents;

    .MuiDrawer-docked {
      display: none;
    }
  }

  .app-content {
    position: relative;
    transition: padding-right 0.2s;

    .app-content-sizer {
      min-height: calc(100vh - 50px - 60px);
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.s}px) {
    grid-template-columns: 240px minmax(0, 1fr);

    .sidebar-container {
      .MuiDrawer-docked {
        display: unset;
      }
    }

    .app-content {
      .app-content-sizer {
        min-height: calc(100vh - 50px);
      }
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.s}px) {
    .sidebar-container {
      display: inherit;
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.l}px) {
    .app-content {
      padding-right: ${({ draftOpened }) => (draftOpened ? '401px' : '0px')};
    }
  }
`

export default StyledAppLayout
